import { Component, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'gl-load-chooser',
    templateUrl: './load-chooser.component.html',
    styleUrls: ['./load-chooser.component.scss'],
    standalone: false
})
export class LoadChooserComponent {
  @Output() public type = new EventEmitter<number>();

  public chooseType(num: number) {
    this.type.emit(num);
  }
}
